import _toConsumableArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { compose, applyMiddleware, createStore, combineReducers } from 'redux';
import { routerMiddleware, connectRouter, ConnectedRouter } from 'connected-react-router';
import createActionBridgeMiddleware from '@clearscore-group/lib.redux.action-bridge-middleware';
import { createEpicMiddleware, combineEpics } from 'redux-observable';
import { createBrowserHistory, createMemoryHistory } from 'history';
import * as sessionTypes from '@clearscore-group/lib.constants.session-action-types';
import { reducers } from '@clearscore-group/lib.redux.market';
import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
import { Provider as Provider$1 } from 'react-redux';
import * as logger from 'redux-logger';

/* eslint-disable prefer-spread */
var regex = /@@redux-form\/(BLUR|FOCUS|CHANGE)/g;
function logging(name) {
  // redux-logger has issue for this https://github.com/LogRocket/redux-logger/issues/233
  // rollup and webpack seem to understand it's build in different way, so need to check,
  // which one is fine
  // @ts-expect-error ts-middleware-issue
  var createLogger = logger.__moduleExports ?
  // @ts-expect-error ts-middleware-issue
  logger.__moduleExports.createLogger : logger.createLogger;
  return createLogger({
    collapsed: function collapsed(getState, action, logEntry) {
      return !(logEntry !== null && logEntry !== void 0 && logEntry.error);
    },
    titleFormatter: function titleFormatter(action, time, took) {
      return '[' + name + '] ' + action.type + ' (' + took.toFixed(2) + 'ms)';
    },
    predicate: function predicate(getState, action) {
      return !action.type.match(regex);
    }
  });
}
var composeWithDevTools = canUseDom() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function () {
  if (arguments.length === 0) return undefined;
  // eslint-disable-next-line prefer-rest-params
  if (typeof arguments[0] === 'object') return compose;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return compose.apply(null, arguments); // eslint-disable-line prefer-rest-params, @typescript-eslint/ban-ts-comment, max-len
};

function composeWithTools(options) {
  if (process.env.DEBUG) {
    options.middleWares.unshift(logging(options.name));
    // @ts-expect-error ts-middleware-issue
    return composeWithDevTools({
      name: options.name
    })(applyMiddleware.apply(null, options.middleWares));
  }
  return compose(applyMiddleware.apply(null, options.middleWares));
}
var Provider = Provider$1;
var Router = ConnectedRouter;
var browserHistory = function browserHistory() {
  var basename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return canUseDom() ? createBrowserHistory({
    basename: basename
  }) : createMemoryHistory({
    initialEntries: [basename || '/']
  });
};
var isCombined = function isCombined(reducers) {
  return typeof reducers === 'function';
};
var combineNestedReducers = function combineNestedReducers(reducers) {
  var nestedReducers = Object.keys(reducers).reduce(function (prev, reducer) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, reducer, typeof reducers[reducer] === 'function' ? reducers[reducer] : combineReducers(reducers[reducer])));
  }, {});
  return combineReducers(nestedReducers);
};
var composeMiddleWares = function composeMiddleWares(_ref) {
  var _ref$pageMiddleWare = _ref.pageMiddleWare,
    _pageMiddleWare = _ref$pageMiddleWare === void 0 ? [] : _ref$pageMiddleWare,
    actionBridgeMiddleWare = _ref.actionBridgeMiddleWare,
    epicMiddleWare = _ref.epicMiddleWare,
    routerMiddleWare = _ref.routerMiddleWare;
  return [actionBridgeMiddleWare, epicMiddleWare, routerMiddleWare].concat(_toConsumableArray(_pageMiddleWare)).filter(function (maybeMiddleware) {
    return Boolean(maybeMiddleware);
  });
};

// Can't use `?` as optional argument, since `reducers` is not in last position so it has
// to be explicitly typed as `undefined`
var createRootReducer = function createRootReducer(reducers, baseReducers) {
  var combinedReducers = isCombined(reducers) ? reducers : combineNestedReducers(_objectSpread(_objectSpread({}, baseReducers), reducers));
  return function (state, action) {
    if ([sessionTypes.LOGOUT_SUBMIT, sessionTypes.TIMEOUT_SUCCESS].includes(action.type)) {
      return combinedReducers(undefined, action);
    }
    return combinedReducers(state, action);
  };
};
/**
 * Returns store
 * @param initialState
 * @param reducers
 * @param name
 * @param appBridgeTypes
 * @param coreDispatch
 * @param pageMiddleWare
 * @param pageEpics
 * @param history
 * @return Object
 * */
function configureStore() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$initialState = _ref2.initialState,
    initialState = _ref2$initialState === void 0 ? {} : _ref2$initialState,
    reducers$1 = _ref2.reducers,
    name = _ref2.name,
    _ref2$appBridgeTypes = _ref2.appBridgeTypes,
    appBridgeTypes = _ref2$appBridgeTypes === void 0 ? [] : _ref2$appBridgeTypes,
    coreDispatch = _ref2.coreDispatch,
    _ref2$pageMiddleWare = _ref2.pageMiddleWare,
    pageMiddleWare = _ref2$pageMiddleWare === void 0 ? [] : _ref2$pageMiddleWare,
    pageEpics = _ref2.pageEpics,
    _ref2$history = _ref2.history,
    history = _ref2$history === void 0 ? browserHistory() : _ref2$history;
  var epicMiddleWare = pageEpics && createEpicMiddleware();
  var actionBridgeMiddleWare = coreDispatch && createActionBridgeMiddleware(coreDispatch, appBridgeTypes);
  var middleWares = composeMiddleWares({
    pageMiddleWare: pageMiddleWare,
    actionBridgeMiddleWare: actionBridgeMiddleWare,
    epicMiddleWare: epicMiddleWare,
    routerMiddleWare: routerMiddleware(history)
  });
  var rootReducer = createRootReducer(reducers$1, {
    router: connectRouter(history),
    market: reducers.domain
  });
  var enhancer = composeWithTools({
    name: name,
    middleWares: middleWares
  });
  var store = createStore(rootReducer, initialState, enhancer);
  if (pageEpics) {
    epicMiddleWare === null || epicMiddleWare === void 0 ? void 0 : epicMiddleWare.run(isCombined(pageEpics) ? pageEpics : combineEpics.apply(void 0, _toConsumableArray(Object.values(pageEpics))));
  }
  return store;
}
export default configureStore;
export { Provider, Router, browserHistory, combineNestedReducers, composeMiddleWares };